// import React from "react";
// import {
//   Box,
//   Card,
//   CardHeader,
//   CardContent,
//   Accordion,
//   AccordionSummary,
//   AccordionDetails,
//   Typography,
//   Grid,
//   List,
//   ListItemButton,
//   ListItemIcon,
//   ListItemText
// } from "@mui/material";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import LinkIcon from "@mui/icons-material/Link";
// import { useTranslation } from "react-i18next";

// // cardData with translation keys
// const cardData = (t) => [
//   {
//     title: t("services.introduction.title"),
//     gradient: "linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)",
//     dropdowns: [
//       {
//         label: t("services.introduction.aboutUs"),
//         url: "/introduction/sploca",
//         links: []
//       },
//       {
//         label: t("services.introduction.compitentAuthority"),
//         links: [
//           // { label: t("services.introduction.authorities"), url: "/contact/departmentcontacts" },
//           { label: t("services.introduction.assignedFE"), url: "/ca/authority/assingnedfe" }
//         ]
//       },
//       {
//         label: t("services.introduction.contact"),
//         links: [
//           { label: t("services.introduction.departmentHeadOffices"), url: "/contact/departmentcontacts" }
//         ]
//       }
//     ]
//   },
//   {
//     title: t("services.kpidfe.title"),
//     gradient: "linear-gradient(135deg, #fbc2eb 0%, #a6c1ee 100%)",
//     dropdowns: [
//       { label: t("services.kpidfe.ffe"), url: "/financial-establishments" },
//       { label: t("services.kpidfe.legalStatus"), url: "https://services.ecourts.gov.in/ecourtindia_v6/" },
//       // { label: t("services.kpidfe.importantLinks"), url: "#" }
//     ]
//   },
//   {
//     title: t("services.onlineServices.title"),
//     gradient: "linear-gradient(135deg, #d4fc79 0%, #96e6a1 100%)",
//     dropdowns: [
//       {
//         label: t("services.onlineServices.claimMgmt"),
//         links: [
//           { label: t("services.onlineServices.claimApp"), url: "/claim-mgmt" },
//           { label: t("services.onlineServices.officersLogin"), url: "/officers-login" }
//         ]
//       },
//       { label: t("services.onlineServices.eofficeMgmt"), url: "https://services.eoffice.gov.in/" },
//       { label: t("services.onlineServices.sakala"), url: "https://sakala.kar.nic.in/index.aspx" },
//       { label: t("services.onlineServices.checkStatus"), url: "/claim-mgmt" }
//     ]
//   },
//   {
//     title: t("services.documents.title"),
//     gradient: "linear-gradient(135deg, #fbc2eb 0%, #a6c1ee 100%)",
//     dropdowns: [
//       // { label: t("services.documents.claimForms"), url: "#" },
//       { label: t("services.documents.circulars"), url: "/notification/circulars" },
//       { label: t("services.documents.departmentOrders"), url: "/ca/authority/govtorders" },
//       { label: t("services.documents.rules"), url: "#" }
//     ]
//   }
// ];

// export const Services = () => {
//   const { t } = useTranslation();

//   return (
//     <Box
//       sx={{
//         width: "100%",
//         backgroundColor: "rgb(175, 213, 235)",
//         mt: 2,
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         py: 4,
//         height: 400,
//         overflowY: "auto"
//       }}
//     >
//       <Grid
//         container
//         spacing={3}
//         justifyContent="center"
//         alignItems="flex-start"
//         sx={{
//           width: "95%",
//           maxWidth: 1200,
//           mt: { xs: 25, md: 0 },
//           "@media (max-width:1100px)": {
//             mt: 25
//           }
//         }}
//       >
//         {cardData(t).map((card, idx) => (
//           <Grid item xs={12} sm={6} md={3} key={idx}>
//             <Card
//               sx={{
//                 borderRadius: 4,
//                 background: card.gradient,
//                 boxShadow: 3,
//                 height: 300,
//                 width: 250,
//                 display: "flex",
//                 flexDirection: "column",
//                 overflowY: "auto"
//               }}
//             >
//               <CardHeader
//                 title={
//                   <Typography
//                     variant="h6"
//                     align="center"
//                     sx={{ fontWeight: "bold" }}
//                   >
//                     {card.title}
//                   </Typography>
//                 }
//                 sx={{
//                   background: "rgba(255,255,255,0.7)",
//                   borderTopLeftRadius: 16,
//                   borderTopRightRadius: 16,
//                   textAlign: "center"
//                 }}
//               />
//               <CardContent
//                 sx={{
//                   flex: 1,
//                   display: "flex",
//                   flexDirection: "column",
//                   gap: 1,
//                   minHeight: 0
//                 }}
//               >
//                 {card.dropdowns.map((dropdown, dIdx) =>
//                   dropdown.links && dropdown.links.length > 0 ? (
//                     // Accordion with links
//                     <Accordion
//                       key={dIdx}
//                       sx={{
//                         borderRadius: 2,
//                         background: "rgba(255,255,255,0.5)",
//                         boxShadow: "none"
//                       }}
//                       disableGutters
//                       elevation={0}
//                     >
//                       <AccordionSummary expandIcon={<ExpandMoreIcon />}>
//                         <Typography sx={{ fontWeight: 600 }}>
//                           {dropdown.label}
//                         </Typography>
//                       </AccordionSummary>
//                       <AccordionDetails sx={{ p: 0 }}>
//                         <List dense>
//                           {dropdown.links.map((link, lIdx) => (
//                             <ListItemButton
//                               key={lIdx}
//                               component="a"
//                               href={link.url}
//                               sx={{
//                                 color: "text.primary",
//                                 fontWeight: 500,
//                                 fontSize: 16,
//                                 px: 2.5,
//                                 py: 1.2,
//                                 borderRadius: 2,
//                                 backgroundColor: "rgba(255,255,255,0.85)",
//                                 boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
//                                 transition:
//                                   "background 0.2s, box-shadow 0.2s, color 0.2s",
//                                 "&:hover": {
//                                   backgroundColor: "primary.light",
//                                   color: "primary.contrastText",
//                                   boxShadow: "0 2px 8px rgba(33,150,243,0.15)",
//                                   textDecoration: "none"
//                                 }
//                               }}
//                             >
//                               <ListItemIcon sx={{ minWidth: 32 }}>
//                                 <LinkIcon
//                                   color="primary"
//                                   fontSize="small"
//                                 />
//                               </ListItemIcon>
//                               <ListItemText primary={link.label} />
//                             </ListItemButton>
//                           ))}
//                         </List>
//                       </AccordionDetails>
//                     </Accordion>
//                   ) : (
//                     // Direct link (no dropdown)
//                     <Accordion
//                       key={dIdx}
//                       sx={{
//                         borderRadius: 2,
//                         background: "rgba(255,255,255,0.5)",
//                         boxShadow: "none"
//                       }}
//                       disableGutters
//                       elevation={0}
//                     >
//                       <AccordionSummary
//                         expandIcon={null}
//                         component="a"
//                         href={dropdown.url}
//                         sx={{
//                           cursor: "pointer",
//                           "&:hover": {
//                             backgroundColor: "primary.light",
//                             color: "primary.contrastText"
//                           }
//                         }}
//                       >
//                         <Typography sx={{ fontWeight: 600 }}>
//                           {dropdown.label}
//                         </Typography>
//                       </AccordionSummary>
//                     </Accordion>
//                   )
//                 )}
//               </CardContent>
//             </Card>
//           </Grid>
//         ))}
//       </Grid>
//     </Box>
//   );
// };

import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Fade,
  Slide,
  Grow,
  useTheme,
  useMediaQuery
} from "@mui/material";
import {
  ExpandMore as ExpandMoreIcon,
  ArrowForwardIos as ArrowIcon,
  Launch as LaunchIcon
} from "@mui/icons-material";
import { useTranslation } from "react-i18next";

// Professional color scheme with better contrast
const cardData = (t) => [
  {
    title: t("services.introduction.title"),
    icon: "🏛️",
    gradient: "linear-gradient(135deg, #E3F2FD 0%, #BBDEFB 100%)",
    accent: "#1976D2",
    textColor: "#1565C0",
    dropdowns: [
      {
        label: t("services.introduction.aboutUs"),
        url: "/introduction/sploca",
        links: [],
        icon: "👥"
      },
      {
        label: t("services.introduction.compitentAuthority"),
        links: [
          { label: t("services.introduction.assignedFE"), url: "/ca/authority/assingnedfe", icon: "⚖️" }
        ],
        icon: "🏢"
      },
      {
        label: t("services.introduction.contact"),
        links: [
          { label: t("services.introduction.departmentHeadOffices"), url: "/contact/departmentcontacts", icon: "📞" }
        ],
        icon: "📍"
      }
    ]
  },
  {
    title: t("services.kpidfe.title"),
    icon: "📊",
    gradient: "linear-gradient(135deg, #F3E5F5 0%, #E1BEE7 100%)",
    accent: "#7B1FA2",
    textColor: "#6A1B9A",
    dropdowns: [
      { label: t("services.kpidfe.ffe"), url: "/ca/authority/assingnedfe", icon: "🏦" },
      { label: t("services.kpidfe.legalStatus"), url: "https://judiciary.karnataka.gov.in/casemenu.php", icon: "⚖️" },
    ]
  },
  {
    title: t("services.onlineServices.title"),
    icon: "💻",
    gradient: "linear-gradient(135deg, #E8F5E8 0%, #C8E6C9 100%)",
    accent: "#388E3C",
    textColor: "#2E7D32",
    dropdowns: [
      {
        label: t("services.onlineServices.claimMgmt"),
        links: [
          { label: t("services.onlineServices.claimApp"), url: "/claim-mgmt", icon: "📝" },
          { label: t("services.onlineServices.officersLogin"), url: "/officers-login", icon: "🔐" }
        ],
        icon: "📋"
      },
      { label: t("services.onlineServices.eofficeMgmt"), url: "https://services.eoffice.gov.in/", icon: "🏢" },
      { label: t("services.onlineServices.sakala"), url: "https://sakala.kar.nic.in/index.aspx", icon: "⏰" },
      { label: t("services.onlineServices.checkStatus"), url: "/claim-mgmt", icon: "🔍" }
    ]
  },
  {
    title: t("services.documents.title"),
    icon: "📑",
    gradient: "linear-gradient(135deg, #FFF3E0 0%, #FFE0B2 100%)",
    accent: "#F57C00",
    textColor: "#EF6C00",
    dropdowns: [
      // { label: t("services.documents.circulars"), url: "/notification/circulars", icon: "📢" },
      { label: t("services.documents.departmentOrders"), url: "/ca/authority/govtorders", icon: "📜" },
      // { label: t("services.documents.rules"), url: "#", icon: "📚" }
    ]
  }
];

const ServiceCard = ({ card, index, isMobile }) => {
  const [expandedDropdown, setExpandedDropdown] = useState(null);
  const [hovered, setHovered] = useState(false);

  const handleDropdownToggle = (index) => {
    setExpandedDropdown(expandedDropdown === index ? null : index);
  };

  return (
    <Grow in={true} timeout={800 + (index * 200)}>
      <Card
        sx={{
          borderRadius: 3,
          background: card.gradient,
          boxShadow: hovered 
            ? "0 12px 40px rgba(0,0,0,0.15), 0 6px 20px rgba(0,0,0,0.12)" 
            : "0 8px 25px rgba(0,0,0,0.1), 0 3px 10px rgba(0,0,0,0.08)",
          height: isMobile ? 340 : 380,
          width: "100%",
          maxWidth: 300,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          position: "relative",
          transition: "all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
          transform: hovered ? "translateY(-6px)" : "translateY(0)",
          border: `2px solid ${hovered ? card.accent : 'transparent'}`,
          cursor: "pointer",
        }}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        {/* Header */}
        <Box
          sx={{
            background: "rgba(255,255,255,0.95)",
            backdropFilter: "blur(10px)",
            borderTopLeftRadius: 12,
            borderTopRightRadius: 12,
            p: 2,
            textAlign: "center",
            position: "relative",
            zIndex: 2,
            borderBottom: `3px solid ${card.accent}`,
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1.5, mb: 1 }}>
            <Typography variant="h4" sx={{ fontSize: '2rem', filter: 'grayscale(0.2)' }}>
              {card.icon}
            </Typography>
          </Box>
          <Typography
            variant="h6"
            sx={{
              fontWeight: "bold",
              color: card.textColor,
              fontSize: { xs: "1rem", sm: "1.1rem" },
              lineHeight: 1.2,
              textShadow: '0 1px 2px rgba(0,0,0,0.1)',
            }}
          >
            {card.title}
          </Typography>
        </Box>

        {/* Content */}
        <CardContent
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            gap: 1.5,
            minHeight: 0,
            p: 2,
            overflowY: "auto",
            '&::-webkit-scrollbar': {
              width: 6,
            },
            '&::-webkit-scrollbar-track': {
              background: 'rgba(0,0,0,0.05)',
              borderRadius: 3,
            },
            '&::-webkit-scrollbar-thumb': {
              background: card.accent,
              borderRadius: 3,
              opacity: 0.6,
            }
          }}
        >
          {card.dropdowns.map((dropdown, dIdx) => (
            <Box key={dIdx}>
              {dropdown.links && dropdown.links.length > 0 ? (
                // Dropdown with nested links
                <Box>
                  <ListItemButton
                    onClick={() => handleDropdownToggle(dIdx)}
                    sx={{
                      borderRadius: 2,
                      background: "rgba(255,255,255,0.8)",
                      border: `1px solid ${card.accent}30`,
                      mb: 0.5,
                      transition: "all 0.3s ease",
                      '&:hover': {
                        background: "rgba(255,255,255,0.95)",
                        transform: "translateX(4px)",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                      }
                    }}
                  >
                    <ListItemIcon sx={{ minWidth: 32, color: card.accent }}>
                      <Typography sx={{ fontSize: '1.1rem' }}>
                        {dropdown.icon}
                      </Typography>
                    </ListItemIcon>
                    <ListItemText 
                      primary={
                        <Typography sx={{ color: card.textColor, fontWeight: 600, fontSize: "0.9rem" }}>
                          {dropdown.label}
                        </Typography>
                      } 
                    />
                    <ExpandMoreIcon 
                      sx={{ 
                        color: card.accent,
                        transform: expandedDropdown === dIdx ? "rotate(180deg)" : "rotate(0deg)",
                        transition: "transform 0.3s ease"
                      }} 
                    />
                  </ListItemButton>

                  {/* Nested Links */}
                  <Slide 
                    direction="up" 
                    in={expandedDropdown === dIdx} 
                    timeout={300}
                    mountOnEnter
                    unmountOnExit
                  >
                    <List dense sx={{ pl: 2, mt: 0.5 }}>
                      {dropdown.links.map((link, lIdx) => (
                        <Fade in={expandedDropdown === dIdx} timeout={500 + (lIdx * 100)} key={lIdx}>
                          <ListItemButton
                            component="a"
                            href={link.url}
                            target={link.url.startsWith('http') ? '_blank' : '_self'}
                            sx={{
                              borderRadius: 2,
                              background: "rgba(255,255,255,0.7)",
                              mb: 0.5,
                              transition: "all 0.3s ease",
                              border: "1px solid rgba(0,0,0,0.1)",
                              '&:hover': {
                                background: "rgba(255,255,255,0.9)",
                                borderColor: card.accent,
                                transform: "translateX(6px)",
                                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                              }
                            }}
                          >
                            <ListItemIcon sx={{ minWidth: 28, color: card.accent }}>
                              <Typography sx={{ fontSize: '0.9rem' }}>
                                {link.icon}
                              </Typography>
                            </ListItemIcon>
                            <ListItemText 
                              primary={
                                <Typography sx={{ color: "#333", fontSize: "0.8rem", fontWeight: 500 }}>
                                  {link.label}
                                </Typography>
                              } 
                            />
                            <LaunchIcon sx={{ fontSize: "0.8rem", color: card.accent, opacity: 0.8 }} />
                          </ListItemButton>
                        </Fade>
                      ))}
                    </List>
                  </Slide>
                </Box>
              ) : (
                // Direct link
                <ListItemButton
                  component="a"
                  href={dropdown.url}
                  target={dropdown.url.startsWith('http') ? '_blank' : '_self'}
                  sx={{
                    borderRadius: 2,
                    background: "rgba(255,255,255,0.8)",
                    border: `1px solid ${card.accent}30`,
                    mb: 0.5,
                    transition: "all 0.3s ease",
                    '&:hover': {
                      background: "rgba(255,255,255,0.95)",
                      transform: "translateX(6px)",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                      borderColor: card.accent,
                    }
                  }}
                >
                  <ListItemIcon sx={{ minWidth: 32, color: card.accent }}>
                    <Typography sx={{ fontSize: '1.1rem' }}>
                      {dropdown.icon}
                    </Typography>
                  </ListItemIcon>
                  <ListItemText 
                    primary={
                      <Typography sx={{ color: card.textColor, fontWeight: 600, fontSize: "0.9rem" }}>
                        {dropdown.label}
                      </Typography>
                    } 
                  />
                  <ArrowIcon sx={{ fontSize: "0.8rem", color: card.accent, opacity: 0.8 }} />
                </ListItemButton>
              )}
            </Box>
          ))}
        </CardContent>
      </Card>
    </Grow>
  );
};

export const Services = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        width: "100%",
        background: "linear-gradient(135deg, #E3F2FD 0%, #F5F5F5 100%)",
        mt: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        py: 6,
        minHeight: "500px",
        position: "relative",
        overflow: "hidden",
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: `
            radial-gradient(circle at 20% 80%, rgba(120, 119, 198, 0.1) 0%, transparent 50%),
            radial-gradient(circle at 80% 20%, rgba(255, 119, 198, 0.08) 0%, transparent 50%),
            radial-gradient(circle at 40% 40%, rgba(120, 219, 255, 0.1) 0%, transparent 50%)
          `,
          animation: 'gradientShift 15s ease infinite',
        },
        '&::after': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: `
            url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z' fill='%239C92AC' fill-opacity='0.05' fill-rule='evenodd'/%3E%3C/svg%3E")
          `,
          animation: 'backgroundMove 60s linear infinite',
        }
      }}
    >
      {/* Floating animated elements */}
      <Box
        sx={{
          position: 'absolute',
          top: '10%',
          left: '5%',
          width: 120,
          height: 120,
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(179, 229, 252, 0.3) 0%, rgba(179, 229, 252, 0) 70%)',
          animation: 'float 15s ease-in-out infinite',
          filter: 'blur(10px)',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          bottom: '15%',
          right: '8%',
          width: 80,
          height: 80,
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(206, 147, 216, 0.2) 0%, rgba(206, 147, 216, 0) 70%)',
          animation: 'float 12s ease-in-out infinite 2s',
          filter: 'blur(8px)',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          top: '60%',
          left: '15%',
          width: 60,
          height: 60,
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(165, 214, 167, 0.2) 0%, rgba(165, 214, 167, 0) 70%)',
          animation: 'float 18s ease-in-out infinite 4s',
          filter: 'blur(6px)',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          top: '20%',
          right: '15%',
          width: 100,
          height: 100,
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(255, 204, 188, 0.2) 0%, rgba(255, 204, 188, 0) 70%)',
          animation: 'float 20s ease-in-out infinite 1s',
          filter: 'blur(12px)',
        }}
      />

      {/* Animated grid lines */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: `
            linear-gradient(90deg, transparent 95%, rgba(120, 120, 120, 0.03) 95%),
            linear-gradient(0deg, transparent 95%, rgba(120, 120, 120, 0.03) 95%)
          `,
          backgroundSize: '50px 50px',
          animation: 'gridMove 40s linear infinite',
          opacity: 0.4,
        }}
      />

      <Grid
        container
        spacing={3}
        justifyContent="center"
        alignItems="center"
        sx={{
          width: "95%",
          maxWidth: 1300,
          position: "relative",
          zIndex: 2,
        }}
      >
        {cardData(t).map((card, idx) => (
          <Grid item xs={12} sm={6} md={3} key={idx} sx={{ display: 'flex', justifyContent: 'center' }}>
            <ServiceCard card={card} index={idx} isMobile={isMobile} />
          </Grid>
        ))}
      </Grid>

      {/* Global styles for animations */}
      <style jsx global>{`
        @keyframes float {
          0%, 100% { 
            transform: translateY(0px) translateX(0px) rotate(0deg); 
          }
          33% { 
            transform: translateY(-20px) translateX(10px) rotate(120deg); 
          }
          66% { 
            transform: translateY(10px) translateX(-15px) rotate(240deg); 
          }
        }
        
        @keyframes gradientShift {
          0%, 100% { 
            opacity: 1;
          }
          50% { 
            opacity: 0.8;
          }
        }
        
        @keyframes backgroundMove {
          0% { 
            background-position: 0 0; 
          }
          100% { 
            background-position: 1000px 1000px; 
          }
        }
        
        @keyframes gridMove {
          0% { 
            background-position: 0 0; 
          }
          100% { 
            background-position: 100px 100px; 
          }
        }
        
        @keyframes pulse {
          0%, 100% { 
            transform: scale(1); 
            opacity: 0.7;
          }
          50% { 
            transform: scale(1.1); 
            opacity: 1;
          }
        }
      `}</style>
    </Box>
  );
};
